import React, { Component } from 'react';
import { convertUnixtodate, getFieldValue } from '../../shared/services/common-functions';
import LabeledInput from '../../shared/components/labeled-input';
import PropTypes from 'prop-types';

class BasicClaimInfo extends Component {

    state = {
        pins: getFieldValue( this.props.claimDetails.product.pin.corrected.digit13 ),
    }

    pins17 = '';

    originalPin = '';

    bmc = '';

    factoryClaimType = '';

    claimType = '';

    creditMemoNumber = '';

    branch = '';

    dealerNum = '';

    fiscalBuildMonth = '';

    fiscalBuildQuarter = '';

    prdSeries = '';

    pip = '';

    failureDate = '';

    fiscalClaimMonth = '';

    regionCode = '';

    dealerNumber = '';

    dealerStateCode = '';

    dealerCountryCode = '';

    processDate = '';

    dealerWorkOrder = '';

    ownerTypeCode = '';

    ownerStatusCode = '';

    customerNumber = '';

    serialNumber = '';


    componentWillReceiveProps ( nextProps ) {

        const claimDetailsPin = nextProps.claimDetails.product.pin.corrected.digit13;
        // You don't have to do this check first, but it can help prevent an unneeded render
        if ( claimDetailsPin !== this.state.pins ) {

            this.updateState( 'pins', claimDetailsPin );

        }

    }

    assignValue = claimDetails => {

        if ( claimDetails !== undefined ) {

            if ( claimDetails.product !== undefined ) {

                this.pins17 = getFieldValue( claimDetails.product.pin.corrected.digit17 ? claimDetails.product.pin.corrected.digit17 : claimDetails.product.pin.original.digit17 );
                this.originalPin = getFieldValue( claimDetails.product.pin.original.digit13 );
                this.prdSeries = getFieldValue( claimDetails.product.productSeriesName );
                this.bmc = getFieldValue( claimDetails.product.baseMachineCode );
                this.serialNumber = getFieldValue( claimDetails.product.serialNumber );

            }

            if ( claimDetails.originalClaim !== undefined ) {

                this.claimType = getFieldValue( `${claimDetails.originalClaim.claimTypeCode} ${' - '} 
                ${claimDetails.originalClaim.claimTypeDescription}` );
                this.creditMemoNumber = getFieldValue(
                    claimDetails.originalClaim.creditMemoNumber,
                );
                this.pip = getFieldValue( claimDetails.originalClaim.pipProgramNumber );
                this.failureDate = convertUnixtodate(
                    getFieldValue( claimDetails.originalClaim.failureDate ),
                );
                this.repairCompletionDate = convertUnixtodate(
                    getFieldValue( claimDetails.originalClaim.repairCompletionDate ),
                );
                this.dealerWorkOrder = getFieldValue( claimDetails.originalClaim.dealerWorkOrder );
                this.processDate = convertUnixtodate(
                    getFieldValue( claimDetails.originalClaim.creditDate ),
                );

            }

            if ( claimDetails.customer !== undefined ) {

                this.ownerTypeCode = getFieldValue( claimDetails.customer.customerTypeCode );
                this.ownerStatusCode = getFieldValue( claimDetails.customer.customerStatusCode );

            }


            this.factoryClaimType = getFieldValue( `${claimDetails.factoryClaimType} ${' - '}
            ${claimDetails.factoryClaimTypeDescription}` );
            this.fiscalBuildMonth = getFieldValue( claimDetails.fiscalBuildMonth );
            this.claimReceivedDate = convertUnixtodate(
                getFieldValue( claimDetails.claimReceivedDate ),
            );
            this.fiscalBuildQuarter = getFieldValue( claimDetails.fiscalBuildQuarter );
            this.fiscalClaimMonth = getFieldValue( claimDetails.fiscalClaimMonth );
            this.regionCode = getFieldValue( `${claimDetails.regionCode} ${' - '} ${claimDetails.regionName} ` );
            this.dealerStateCode = getFieldValue( claimDetails.dealerStateCode );
            this.dealerCountryCode = getFieldValue( claimDetails.dealerCountryCode );
            this.branch = getFieldValue( claimDetails.geoGraphicBranch.original );
            this.dealerNum = getFieldValue( claimDetails.dealer.original );
            this.dealerNumber = `${this.branch}${this.dealerNum}`;
            this.customerNumber = getFieldValue( claimDetails.customer.customerNumber );
            this.warrantyClaimId = getFieldValue( claimDetails.warrantyClaimId );

        }

    }

    onEditBtnClicked = () => {

        this.props.enableEditCmp( 'Basic Claim' );

    }


    onSaveBtnClicked = () => {

        if ( this.props.claimDetails.product.pin.corrected.digit13 !==
            this.state.pins ) {

            this.props.updateClaim( 'basic', this.state.pins );

        } else this.onCancelBtnClicked();

    }

    onCancelBtnClicked = () => {

        if ( this.props.enableEditCmp( 'Basic Claim' ) ) {

            this.setState( {

                pins: this.props.claimDetails.product.pin.corrected.digit13,

            } );

        }

    }

    updatedPinValue = pin => {

        this.updateState( 'pins', pin.target.value );

    }

    updateState = ( propName, propValue ) => {

        this.setState( {
            [propName]: propValue,
        } );

    }

    render () {

        this.assignValue( this.props.claimDetails );

        return (
            <div className="basic-claim ">
                <section className="claim-information">
                    <header>
                        {this.props.isComponentEdit && (
                            <h4 className="page-header">
                                <i title="Edit" className={`fa fa-edit ${!this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onEditBtnClicked} />
                                <i className={`fa fa-save ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onSaveBtnClicked} />
                                <i className={`fa fa-remove ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onCancelBtnClicked} />
                            </h4>
                        )}
                    </header>
                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="correctedPin"
                                isEditable={this.props.isEdit}
                                label="PIN"
                                value={this.state.pins}
                                onChange={this.updatedPinValue.bind( this )}
                            />
                            {this.pins17}

                        </div>
                        <div className="four-cols">

                            <LabeledInput
                                className="basic-claim-info"
                                name="originalPin"
                                isEditable={false}
                                label="Original PIN"
                                value={this.originalPin}
                            />
                        </div>
                        <div className="four-cols">

                            <LabeledInput
                                className="basic-claim-info"
                                name="factoryClaimType"
                                isEditable={false}
                                label="Factory Claim type"
                                value={this.factoryClaimType}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="claimTypeCode"
                                isEditable={false}
                                label="Claim Type"
                                value={this.claimType}
                            />
                        </div>
                    </div>
                    {/* <hr></hr>  */}
                    <div className="rows">

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="creditMemoNumber"
                                isEditable={false}
                                label="Credit Memo #"
                                value={this.creditMemoNumber}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="serialNumber"
                                isEditable={false}
                                label="Serial Number"
                                value={this.serialNumber}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="bmc"
                                isEditable={false}
                                label="BMC"
                                value={this.bmc}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="productSeriesName"
                                isEditable={false}
                                label="Product Series"
                                value={this.prdSeries}
                            />
                        </div>
                    </div>
                    {/* <hr></hr> */}
                    <div className="rows">

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="fiscalBuildMonth"
                                isEditable={false}
                                label="Build Month"
                                value={this.fiscalBuildMonth}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="fiscalBuildQuarter"
                                isEditable={false}
                                label="Build Quarter"
                                value={this.fiscalBuildQuarter}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="pipProgramNumber"
                                isEditable={false}
                                label="PIP Number"
                                value={this.pip}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="fiscalClaimMonth"
                                isEditable={false}
                                label="Fiscal Claim Month"
                                value={this.fiscalClaimMonth}
                            />
                        </div>

                    </div>
                    {/* <hr></hr> */}
                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="failureDate"
                                isEditable={false}
                                label="Failure Date"
                                value={this.failureDate}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="repairCompletionDate"
                                isEditable={false}
                                label="Repair Completion Date"
                                value={this.repairCompletionDate}
                            />
                        </div>


                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="claimReceivedDate"
                                isEditable={false}
                                label="Claim Recieved Date"
                                value={this.claimReceivedDate}
                            />
                        </div>


                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="processDate"
                                isEditable={false}
                                label="Process Date"
                                value={this.processDate}
                            />
                        </div>
                    </div>
                    {/* <hr></hr> */}
                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="regionCode"
                                isEditable={false}
                                label="Region Code"
                                value={this.regionCode}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="dealerNumber"
                                isEditable={false}
                                label="Dealer Number"
                                value={this.dealerNumber}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="dealerStateCode"
                                isEditable={false}
                                label="Dealer State"
                                value={this.dealerStateCode}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="dealerCountryCode"
                                isEditable={false}
                                label="Dealer Country"
                                value={this.dealerCountryCode}
                            />
                        </div>
                    </div>
                    {/* <hr></hr> */}
                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="dealerWorkOrder"
                                isEditable={false}
                                label="Dealer Work Order"
                                value={this.dealerWorkOrder}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="customerNumber "
                                isEditable={false}
                                label="Customer Number"
                                value={this.customerNumber}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="ownerStatusCode"
                                isEditable={false}
                                label="Owner Status Code"
                                value={this.ownerStatusCode}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="ownerTypeCode"
                                isEditable={false}
                                label="Owner Type Code"
                                value={this.ownerTypeCode}
                            />
                        </div>
                    </div>
                </section>


            </div>
        );

    }

}
BasicClaimInfo.displayName = 'BasicClaimInfo';
BasicClaimInfo.propTypes = {
    claimDetails: PropTypes.object.isRequired,
    updateClaim: PropTypes.func.isRequired,
    isComponentEdit: PropTypes.bool.isRequired,
    enableEditCmp: PropTypes.func,
    isEdit: PropTypes.bool.isRequired,
};
export default BasicClaimInfo;
